import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';

export interface SelfAppAverageSummaryEntityProps {
  totalDuration: number;
  count: number;
  totalCallDuration: number;
  callCount: number;
  dayCount: number;
  weekCount: number;
}

export class SelfAppAverageSummaryEntity extends Entity<SelfAppAverageSummaryEntityProps> {
  protected _id: string;
  static create(
    props: SelfAppAverageSummaryEntityProps,
    entityId?: string
  ): SelfAppAverageSummaryEntity {
    const id = entityId || v4();
    const entity = new SelfAppAverageSummaryEntity({
      id,
      props,
    });
    return entity;
  }
  public validate() {}

  get averageDailyDuration() {
    return this.props.dayCount > 0
      ? this.props.totalDuration / this.props.dayCount
      : this.props.totalDuration;
  }
  get averageWeeklyDuration() {
    return this.props.weekCount > 0
      ? this.props.totalDuration / this.props.weekCount
      : this.props.totalDuration;
  }
  get averageDailyInteractions() {
    return this.props.dayCount > 0
      ? this.props.count / this.props.dayCount
      : this.props.count;
  }
  get averageWeeklyInteractions() {
    return this.props.weekCount > 0
      ? this.props.count / this.props.weekCount
      : this.props.count;
  }
  get averageDailyCallInteractions() {
    return this.props.dayCount > 0
      ? this.props.callCount / this.props.dayCount
      : this.props.callCount;
  }
  get averageWeeklyCallInteractions() {
    return this.props.weekCount > 0
      ? this.props.callCount / this.props.weekCount
      : this.props.callCount;
  }
  get averageDailyCallDuration() {
    return this.props.dayCount > 0
      ? this.props.totalCallDuration / this.props.dayCount
      : this.props.totalCallDuration;
  }
  get averageWeeklyCallDuration() {
    return this.props.weekCount > 0
      ? this.props.totalCallDuration / this.props.weekCount
      : this.props.totalCallDuration;
  }
}
